import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// Detects a new deploy by reading the hashed JS bundle name from index.html (always present +
// served no-cache). When the hash changes after a deploy, shows a non-dismissable "update
// available" banner with a Refresh button. No dependency on version.json.
export default function UpdateBanner() {
  const [update, setUpdate] = useState(false);
  const loaded = useRef(null);
  const { pathname } = useLocation();
  const { user } = useAuth();
  // Only inside the logged-in app (dashboard), and only for approved accounts —
  // never on the public site or behind the "pending approval" overlay.
  const inApp = pathname.startsWith('/dashboard') && user?.approval_status === 'approved';

  useEffect(() => {
    let stopped = false;
    const check = async () => {
      try {
        const r = await fetch(`/?t=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const html = await r.text();
        const m = html.match(/main\.([a-z0-9]+)\.js/i);       // hashed bundle → build fingerprint
        const v = m ? m[1] : null;
        if (!v) return;
        if (loaded.current == null) loaded.current = v;       // first load = current build
        else if (v !== loaded.current && !stopped) setUpdate(true);
      } catch (_) { /* offline / transient — ignore */ }
    };
    check();
    const id = setInterval(check, 120000);                    // every 2 min
    const onFocus = () => check();                            // and when tab regains focus
    window.addEventListener('focus', onFocus);
    return () => { stopped = true; clearInterval(id); window.removeEventListener('focus', onFocus); };
  }, []);

  if (!update || !inApp) return null;

  return (
    <div style={s.wrap}>
      <span style={s.text}><RefreshCw size={15} /> A new update is available.</span>
      <button style={s.btn} onClick={() => window.location.reload()}>Refresh</button>
    </div>
  );
}

const s = {
  wrap: { position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 4000, display: 'flex', alignItems: 'center', gap: 14, background: '#0f172a', color: '#fff', borderRadius: 12, padding: '11px 16px', boxShadow: 'var(--mc-e4)', fontSize: 14 },
  text: { display: 'flex', alignItems: 'center', gap: 8, fontWeight: 600 },
  btn: { background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 16px', fontWeight: 700, cursor: 'pointer', fontSize: 13 },
};
